import { MAINTENANCE_MODE } from 'constants/features';
import { useFeatureFlags } from 'hooks/useFeatureFlags/useFeatureFlags';
import { useSelector } from 'react-redux';
import { getRecipientId } from 'selectors/entities/recipient/recipient';

function useMaintenanceMode() {
  const isFeatureEnabled = useFeatureFlags(MAINTENANCE_MODE);
  const recipientId = useSelector(getRecipientId);

  return isFeatureEnabled && recipientId !== undefined && recipientId !== 'PTU';
}

export { useMaintenanceMode };
